var App = App || {};

App.NowrapArrows = (function ($) {
    'use strict';

    function Init() {
        const nowrapArrows = $("a .nowrap-arrow");

        nowrapArrows.each(function () {
            const iconHtml = "<span class=\"arrow fal fa-arrow-right\"></span>";

            const trimmed = $(this).text().trim();
            const lastSpaceIndex = trimmed.lastIndexOf(' ');

            const before = trimmed.slice(0, lastSpaceIndex);
            const last = trimmed.slice(lastSpaceIndex + 1);

            var htmlString = "<span class=\"text\">";
            if (lastSpaceIndex != -1 && lastSpaceIndex != trimmed.length) {
                htmlString += before + ' ';
            }
            $(this).html(htmlString + `<span style="white-space:nowrap">${last} ${iconHtml}</span></span>`);

        });
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.NowrapArrows.Init();
});